var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"node"},[_vm._v(_vm._s(_vm.name)+" "),_c('div',{staticClass:"popup"})])
}
var staticRenderFns = []

export { render, staticRenderFns }